<template>
  <div class="carTree-div" @click="carTreeClick">
    <!-- <div class="search-top">
        <el-button type="text">批量操作22</el-button>
        <el-button class="base-button" @click="message" size="mini" type="primary"
                  icon="el-icon-chat-dot-round">实时通讯</el-button>
        <el-button size="mini" type="primary" icon="el-icon-location-outline">导航</el-button>
              <el-button size="mini" type="primary" icon="el-icon-search">搜索</el-button>
      </div> -->
    <el-tree
      @node-contextmenu="contextmenu"
      :expand-on-click-node="false"
      @check-change="checkChange"
      :data="Listdata"
      show-checkbox
      default-expand-all
      node-key="name"
      ref="tree"
      highlight-current
      :props="defaultProps"
      @node-click="handleNodeClick"
    >
      <!-- <span @node-contextmenu="contextmenu" class="custom-tree-node-card" slot-scope="{ node, data }">
                  <span>{{ node.label }}</span>
              </span> -->
    </el-tree>
    <div class="menu-bottom">
      <div @click="manage" class="menu">
        <img src="../../assets/cd.png" />
        菜单管理
      </div>
      <div @click="commrecord" class="menu">
        <img src="../../assets/tx.png" />
        实时通讯
      </div>
    </div>
  </div>
</template>
<script>
import {
  getZTreeGroupDevice,
  getlistDeviceLocation,
  deleteDeviceGroup,
} from "@/api/device/index.js";
import Add from "./add.vue";
import Edit from "./edit.vue";
import Manage from "./manage.vue";
import sendMsg from "./sendMsg.vue";
import mesTabs from "../mesTabs/index.vue";
import Commrecord from "@/views/commrecord/index.vue"; //历史通讯
import PopLayer from "@/utils/cesiumBD/animation/PopLayer";
import DeviceMsg from "../DeviceMsg/index.vue";
import { getSurfaceHeight } from "@/utils/cesiumBD/analysis/utils/index";
import sendPageCM from "./sendPageCM.vue";
window.rightIns = undefined;
export default {
  data() {
    return {
      Listdata: [
        {
          id: 1,
          name: "监控中心",
          children: [],
        },
      ],
      defaultProps: {
        children: "children",
        label: "name",
      },
      allCards: [],
    };
  },
  created() {
    this.getTree();
    this.getAllCards();
  },
  mounted() {
    this.$bus.$on("card-list", () => {
      this.getTree();
      this.getAllCards();
    });
  },
  beforeDestroy() {
    this.$bus.$off("card-list");
  },
  methods: {
    batchDo() {
      this.$dialog.open({
        title: "批量操作",
        theme: "feature-dialog",
        shade: true,
        area: {
          height: "300px",
          width: "680px",
        },
        // location: {
        //     top: "100px",
        // },
        content: {
          type: "vue",
          subCom: sendPageCM,
          subData: {},
        },
      });
    },
    handleNodeClick(item, node, el) {
      this.$refs["tree"].setChecked(node.data, !node.checked, false);
    },
    carTreeClick() {
      this.closeMsg();
    },
    closeMsg() {
      if (window.rightIns) {
        this.$dialog.close(window.rightIns);
        window.rightIns = undefined;
      }
    },
    contextmenu(event, data, node, el) {
      this.closeMsg();
      //"Device_460228"
      var model = data.model || "";
      var node_type = model.split("_")[0];
      if (node_type != "Device") {
        //return;
      }
      var pageX = event.pageX;
      var pageY = event.pageY + 10;
      window.rightIns = this.$dialog.open({
        shade: false,
        hasHead: false,
        theme: "right-dialog",
        location: {
          left: pageX + "px",
          top: pageY + "px",
          right: undefined,
          bottom: undefined,
        },
        content: {
          type: "vue",
          subCom: sendMsg,
          subData: data,
        },
      });
    },
    manage() {
      var ins = this.$dialog.getDialog("菜单管理");
      if (ins) {
        return;
      }
      this.$dialog.open({
        id: "菜单管理",
        title: "菜单管理",
        theme: "feature-dialog",
        shade: true,
        area: {
          height: "600px",
          width: "600px",
        },
        location: {
          top: "100px",
        },
        content: {
          type: "vue",
          subCom: Manage,
        },
      });
    },
    commrecord() {
      var ins = this.$dialog.getDialog("实时通讯");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "实时通讯",
        title: "实时通讯",
        theme: "feature-dialog",
        area: {
          height: "520px",
          width: "1200px",
        },
        location: {
          top: "100px",
        },
        content: {
          type: "vue",
          subCom: Commrecord,
        },
      });
    },
    message() {
      var ins = this.$dialog.getDialog("实时通讯");
      if (ins) {
        return;
      }
      this.$dialog.open({
        id: "实时通讯",
        title: "实时通讯",
        theme: "feature-dialog",
        area: {
          height: "300px",
          width: "calc(100vw - 320px)",
        },
        location: {
          bottom: "31px",
          right: "0px",
        },
        content: {
          type: "vue",
          subCom: mesTabs,
        },
      });
    },
    append(node, data) {
      if (!data.model) {
        return;
      }
      this.$dialog.open({
        title: "添加节点",
        shade: true,
        area: {
          height: "350px",
          width: "500px",
        },
        location: {
          top: "100px",
        },
        content: {
          type: "vue",
          subCom: Add,
          subData: data,
        },
      });
    },
    editNode(node, data) {
      if (!data.model) {
        return;
      }
      this.$dialog.open({
        title: "修改节点",
        shade: true,
        area: {
          height: "350px",
          width: "500px",
        },
        location: {
          top: "100px",
        },
        content: {
          type: "vue",
          subCom: Edit,
          subData: data,
        },
      });
    },
    remove(node, data) {
      if (!data.model) {
        return;
      }
      var id = data.model.split("_")[1];
      this.$confirm("是否删除该节点?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteDeviceGroup({ id: id }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });

            this.getTree();
            this.getAllCards();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    checkChange(item, bool, cBool) {
      console.log(item);
      this.closeMsg();
      if (!item.model) {
        return;
      }
      var car_num = item.model.split("_")[1];
      let baseH = 8000; //基础高度8千米
      var card = this.findCardByNum(car_num);
      if (card && !item.children) {
        var id = car_num + "_小飞机";
        var entity = DBentityCollection.getById(id);
        if (!entity) {
          return;
          var p = Cesium.Cartesian3.fromDegrees(
            card.longitude,
            card.latitude,
            card.altitude + baseH
          );
          entity = this.createBillboardEntity(p, car_num, item.name);
          DBentityCollection.add(entity);
          var pop = new PopLayer({
            entity: entity,
            dialog: this.$dialog,
            componet: DeviceMsg,
            subData: car_num,
            title: "设备信息",
          });

          entity.show = bool;
          viewer.flyTo(entity, {
            duration: 3,
            offset: new Cesium.HeadingPitchRange(0, -Math.PI / 2, 24000), //（heading,pich,range）
          });

          return;
        }
        entity.show = bool;
        viewer.flyTo(entity, {
          duration: 3,
          offset: new Cesium.HeadingPitchRange(0, -Math.PI / 2, 24000), //（heading,pich,range）
        });
      }
    },
    //图标
    createBillboardEntity(center, id, text) {
      const entity = new Cesium.Entity({
        id: id,
        position: center,
        label: {
          text: text || "航线",
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          font: "20px sans-serif",
          pixelOffset: new Cesium.Cartesian2(0, -40),
          fillColor: Cesium.Color.YELLOW,
          //pixelOffsetScaleByDistance: new Cesium.NearFarScalar(1.0e3, -20, 1.5e6, -80),
        },
        model: {
          show: true,
          uri: "data/mx/feiji.glb", //模型的地址
          scale: 40, //模型缩放比例
          minimumPixelSize: 20, //
          maximumScale: 20000, // 模型的最大比例尺大小。 minimumPixelSize的上限
          incrementallyLoadTextures: true, // 加载模型后纹理是否可以继续流入
          runAnimations: true, // 是否应启动模型中指定的glTF动画
          clampAnimations: true, // 指定glTF动画是否应在没有关键帧的持续时间内保持最后一个姿势
          shadows: Cesium.ShadowMode.ENABLED,
          heightReference: Cesium.HeightReference.NONE, //设置模型贴地,
        },
      });
      return entity;
    },
    findCardByNum(num) {
      var resList = this.allCards.filter((c) => {
        return c.cardNumber == num;
      });

      return resList && resList.length > 0 ? resList[0] : undefined;
    },
    getAllCards() {
      getlistDeviceLocation()
        .then((res) => {
          this.allCards = res.result;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    getTree() {
      getZTreeGroupDevice()
        .then((res) => {
          var list = res.result || [];
          this.Listdata[0].children = list;
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.carTree-div {
  height: 100%;
}

.search-top {
  margin-bottom: 0;
  text-align: center;
  .el-button--text {
    color: #000;
  }
}
.menu-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .menu {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #424a6b;
    padding: 10px 0;
    cursor: pointer;
    img {
      width: 22px;
      height: 22px;
      margin: 0 6px;
    }
  }
}
</style>

<style lang="scss">
.custom-tree-node-card {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 12px;
}

.custom-tree-node-card .operate {
  margin-left: 10px;
}

.carTree-div {
  .el-tree {
    background: transparent;
    color: #ffffff;
    height: 700px;
    overflow-y: auto;

    .el-tree-node__content:hover,
    .el-upload-list__item:hover {
      background-color: transparent;
      color: #83e9ff;
    }

    .el-checkbox__inner {
      background-color: transparent;
    }
  }

  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: transparent !important;
    color: #83e9ff !important;
  }

  .el-tree-node__expand-icon {
    color: #ffffff !important;
  }

  .el-tree-node:focus > .el-tree-node__content {
    background-color: transparent !important;
  }
}
</style>
